module.exports = __webpack_public_path__ + "static/media/ic_more.eae49b0c.svg";